import { Component, OnInit, ChangeDetectionStrategy, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from '@env/environment';
import { Store } from '@ngrx/store';
import { IAppState } from '@app/store';
import * as fromCatalog from '@app/+catalog/store/reducers';
import { TrackPersonalization } from '@app/+catalog/store';

@Component({
  selector: 'vc-modal-personalization',
  templateUrl: './modal-personalization.component.html',
  styleUrls: ['./modal-personalization.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class ModalPersonalizationComponent implements OnInit {
  config = {
    env: environment.envName
  };

  public isEditView = false;

  public sizeStandards = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ModalPersonalizationComponent>,
    private store: Store<IAppState>
  ) {
    this.sizeStandards = data?.sizeStandards;
  }

  ngOnInit(): void {
    this.store.select(fromCatalog.getPersonalization).subscribe(
      res => {
        this.isEditView = res?.preferences?.universe?.ids.length > 0;
      },
      error => {
        console.error(error);
      }
    );
  }

  closeModal() {
    this.dialogRef.close();
  }

  onSave(event) {
    if (this.isEditView) {
      this.editCompleted(event);
    } else {
      this.onboardingCompleted(event);
    }
  }

  onboardingCompleted(event: { detail: { universe: number[] } }) {
    this.store.dispatch(
      new TrackPersonalization({
        event: 'preferences_created',
        eventAction: 'onboarding process',
        eventLabel: 'personalization enabled',
        perso_universe: event?.detail?.universe?.reduce((acc, curr) => acc + +curr, 0) // 1: Women, 2: Men, 3: Women & Men
      })
    );
  }

  editCompleted(event: { detail: { universe: number[] } }) {
    let options = {
      event: 'edit_preferences_confirmation',
      eventAction: 'edit perso',
      eventLabel: 'save'
    };
    if (event?.detail?.universe.length < 1) {
      options = {
        event: 'my preference',
        eventAction: 'delete preferences',
        eventLabel: 'confirm'
      };
    }
    this.store.dispatch(new TrackPersonalization(options));
  }
}
